import { createSvgComponent } from "../../../icon/createSvgComponent";
import WelloHelperMark from "../../../icon/assets/wello-helper-mark.svg";
export default createSvgComponent(WelloHelperMark);